import { TICKER_NEWS } from "../../../mocks/gossip";

export default function Ticker() {
  return (
    <div className="container-x mt-6 md:mt-8">
      <div className="flex items-stretch overflow-hidden rounded-xl border border-background-200 bg-background-100/70">
        <div className="flex shrink-0 items-center gap-1.5 bg-primary-500 px-3.5 text-sm font-bold text-background-50 md:px-5">
          <i className="ri-flashlight-line text-base" />
          <span className="whitespace-nowrap text-[13px] md:text-sm">刚刚爆</span>
        </div>
        <div className="relative flex flex-1 items-center overflow-hidden px-4">
          <div className="scrollbar-hide flex items-center gap-8 overflow-x-auto py-3">
            {TICKER_NEWS.map((news, i) => (
              <a
                key={i}
                href="#breaking"
                className="flex shrink-0 items-center gap-2 text-sm text-foreground-700 transition-colors hover:text-primary-600"
              >
                <span className="inline-flex h-1.5 w-1.5 shrink-0 animate-pulse rounded-full bg-accent-500" />
                <span className="whitespace-nowrap">{news}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}